module.exports = __webpack_public_path__ + "img/template_placeholder_purple.7187688.png";